var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8741 18.967C21.9943 18.81 22.0311 18.6115 21.9729 18.4224C21.8043 17.8646 21.4553 17.2916 20.9358 16.7225C20.5868 16.3405 20.3949 15.8394 20.3949 15.3137V13.2867C20.3949 10.9231 18.4233 9 16 9C13.5767 9 11.6051 10.9231 11.6051 13.2867V15.3137C11.6051 15.8394 11.4132 16.3405 11.0642 16.7225C10.5466 17.2916 10.1976 17.8646 10.027 18.4224C9.96889 18.6115 10.0057 18.8081 10.1259 18.967C10.2461 19.1239 10.4303 19.2147 10.6319 19.2147H21.3642C21.5658 19.2147 21.75 19.1239 21.8702 18.967H21.8741Z",
    fill: "#001F3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 20.1428H13.9998C14.0161 21.1682 14.9072 22 15.9998 22C17.0924 22 17.9835 21.1701 17.9998 20.1428Z",
    fill: "#001F3B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ebcd56981b9dc1b72b13c22688ed5a38.svg";
export { ForwardRef as ReactComponent };